<script lang="ts">
	import { Container, Select, Stack, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import {
		handleSelectChange,
		weekModelSelectOptionAt,
		type TariffTables,
	} from '../helpers/daisy_em_tariff_helpers';

	export let tariffTables: TariffTables;

	$: weekModelOptions = Array.from({ length: tariffTables.weeks.length }, (_, i) => ({
		value: `W${i + 1}`,
		title: $format('daisy_em_tariff_week_model_option', {
			values: { n: i + 1 },
			default: `Week model ${i + 1}`,
		}),
	}));

	/**
	 * Handles the Select change event for a season's week pattern assignment.
	 * @param seasonIdx - 0 for standard time, 1 for DST.
	 * @param e - Change event from the Select component.
	 */
	const handleSeasonChange = (seasonIdx: 0 | 1, e: CustomEvent) => {
		const v = handleSelectChange(e);
		const idx = weekModelOptions.findIndex((o) => o.value === v);
		const seasons: [number, number] = [tariffTables.seasons[0], tariffTables.seasons[1]];
		seasons[seasonIdx] = idx >= 0 ? idx : 0;
		tariffTables = { ...tariffTables, seasons };
	};
</script>

<Text styleType="h2" class="mb-s mt-m">
	{$format('daisy_em_tariff_seasons', { default: 'Season Schedule' })}
</Text>
<Container type="borderSolid" backgroundColor="color-base" class="mb-l">
	<Stack align="between" direction="column" gap="m" class="align-items-center mb-s">
		<Text styleType="body" class="text-color-muted">
			{$format('daisy_em_tariff_standard_time', { default: 'Standard time' })}
		</Text>

		<Select
			id="season-std"
			aria-label={$format('daisy_em_tariff_season_std_week_model', {
				default: 'Week model for standard time',
			})}
			size="m"
			icon="fas fa-sun"
			width="l"
			value={weekModelSelectOptionAt(weekModelOptions, tariffTables.seasons[0])}
			options={weekModelOptions}
			on:change={(e) => handleSeasonChange(0, e)}
		/>
	</Stack>

	<Stack align="between" direction="column" gap="m" class="d-flex align-items-center">
		<Text styleType="body" class="text-color-muted">
			{$format('daisy_em_tariff_dst', { default: 'DST' })}
		</Text>
		<Select
			id="season-dst"
			aria-label={$format('daisy_em_tariff_season_dst_week_model', {
				default: 'Week model for daylight saving time',
			})}
			size="m"
			width="l"
			icon="fas fa-sun"
			value={weekModelSelectOptionAt(weekModelOptions, tariffTables.seasons[1])}
			options={weekModelOptions}
			on:change={(e) => handleSeasonChange(1, e)}
		/>
	</Stack>
</Container>
